import abstractModel from '../../core/MercatelyModel';
import { serializeParams } from '../../util/urlUtils';

const resource = '/api/mia/chatbot/history';

const model = abstractModel(resource);
const parentGet = model.get;

model.get = async (params = {}, newResource = {}) => {
  if (params && typeof params === 'object' && !Array.isArray(params)) {
    const hasArrayParams = Object.values(params).some(value => Array.isArray(value));

    if (hasArrayParams) {
      const queryString = serializeParams(params);
      return parentGet({}, { ...newResource, filters: queryString });
    }
  }

  const queryString = serializeParams(params);
  return parentGet({}, { path: `${resource}?${queryString}` });
};

export default model;
